import desvincularproyecto from "./desvincularproyecto.png";
import comentariocancelar from "./comentariocancelar.png";
import comentarioCompleto from "./comentarioCompleto.png";
import completarProyecto from "./completarProyecto.png";
import terminarCompletar from "./terminarCompletar.png";
import continueCancelar from "./continueCancelar.png";
import proyeccion from "./proyeccion.png";
import simulacion from "./simulacion.png";
import closemenu from "./closemenu.png";
import compartir from "./compartir.png";
import cancelar from "./cancelar.png";
import openmenu from "./openmenu.png";
import reanudar from "./reanudar.png";
import pause from "./pause.png";
import task from './task.png'

export const iconsDetailsProyectMenu = {
    desvincularproyecto,
    cancelar,
    closemenu,
    comentariocancelar,
    compartir,
    openmenu,
    proyeccion,
    reanudar,
    simulacion,
    pause,
    completarProyecto,
    terminarCompletar,
    comentarioCompleto,
    continueCancelar,
    task
};

